module.exports = __webpack_public_path__ + "static/q9_x-89a456d1507573c6f138ef4d9522e630.png";